<template>
    <div class="main-content">
        <h1 v-translate>
            My People
        </h1>
        <div class="main-content__my-people">
            <div class="content-navigation">
                <ul class="content-navigation__container">
                    <li>
                        <router-link active-class="content-navigation__link--active" :to="{name: 'my-people-all'}"
                                     class="content-navigation__link">
                            <translate>All</translate>
                        </router-link>
                    </li>
                    <li>
                        <router-link active-class="content-navigation__link--active" :to="{name: 'my-family'}"
                                     class="content-navigation__link">
                            <translate>My Family</translate>
                        </router-link>
                    </li>
                    <li>
                        <router-link active-class="content-navigation__link--active" :to="{name: 'my-friends'}"
                                     class="content-navigation__link">
                            <translate>My Friends</translate>
                        </router-link>
                    </li>
                    <li>
                        <router-link active-class="content-navigation__link--active" :to="{name: 'business-professionals'}"
                                     class="content-navigation__link">
                            <translate>Business Professionals</translate>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div key="family" v-if="tab_location == 'my-family' || tab_location == 'all'">
                <h2 v-translate>My Family</h2>
                <div class="my-people__container">
                    <button class="my-people__member add-new-button"
                            @click="addPeople('family')">
                        <div class="add-new-button__icon icon icon-plus"></div>
                        <div class="add-new-button__text" v-translate>
                            Add new <strong>Family member</strong>
                        </div>
                    </button>
                    <person v-for="person in family" :person="person" :key="person.id"/>
                </div>
            </div>

            <div key="friends" v-if="tab_location == 'my-friends' || tab_location == 'all'">
                <h2 v-translate>My Friends</h2>
                <div class="my-people__container">
                    <button class="my-people__member add-new-button"
                            @click="addPeople('friends')">
                        <div class="add-new-button__icon icon icon-plus"></div>
                        <div class="add-new-button__text" v-translate>
                            Add new <strong>Friend</strong>
                        </div>
                    </button>
                    <person v-for="person in friends" :person="person" :key="person.id"/>
                </div>
            </div>

            <div key="business-professionals" v-if="tab_location == 'business-professionals' || tab_location == 'all'">
                <h2 v-translate>Business Professionals</h2>
                <div class="my-people__container">
                    <button class="my-people__member add-new-button"
                            @click="addPeople('business')">
                        <div class="add-new-button__icon icon icon-plus"></div>
                        <div class="add-new-button__text" v-translate>
                            Add new <strong>Business Professional</strong>
                        </div>
                    </button>
                    <person v-for="person in business" :person="person" :key="person.id"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AddPeople from "./popups/AddPeople";
    import EditPeople from "./popups/EditPeople";
    import UsersSuccessProfile from './popups/UsersSuccessProfile';
    import {mapActions} from 'vuex';
    import Person from "../components/my-people/Person";
    import axios from "axios";
    import {EventBus} from '../event-bus';
    import PersonRequestAdded from "./popups/PersonRequestAdded";

    export default {
        name: 'MyPeople',
        components: {Person},
        data() {
            return {
                add_people: AddPeople,
                edit_people: EditPeople,
                users_success_profile: UsersSuccessProfile,
                people: [],
                loading: true,
            }
        },
        computed: {
            tab_location: function () {
                if (this.$route.name === 'my-people-all') {
                    return 'all'
                }
                return this.$route.name
            },
            family: function () {
                return this.people.filter(person => person.person_type === 'family');
            },
            friends: function () {
                return this.people.filter(person => person.person_type === 'friends');
            },
            business: function () {
                return this.people.filter(person => person.person_type === 'business');
            }
        },
        methods: {
            ...mapActions([
                'openPopup',
                'setPopupPayload'
            ]),
            addPeople: function (type) {
                this.setPopupPayload(type)
                this.openPopup(AddPeople)
            },
            loadPeople: async function () {
                this.loading = true;
                this.people = (await axios.get('/api/navigator/people/')).data
                this.loading = false;
            },
            updatePerson: function (person) {
                let that = this;
                this.people.forEach((element, index) => {
                    if (element.id === person.id) {
                        that.$set(that.people, index, person);
                    }
                });
            },
            createPerson: function (person) {
                this.people.push(person)
            },
            createPersonRequest: function () {
                let that = this;
                setTimeout(function () {
                    that.openPopup(PersonRequestAdded)
                }, 1000)
            }
        },
        beforeMount: function () {
            this.loadPeople()
        },

        created: function () {
            EventBus.$on('update_person', this.updatePerson)
            EventBus.$on('create_person', this.createPerson)
            EventBus.$on('create_person_request', this.createPersonRequest)
        },
        beforeDestroy: function () {
            EventBus.$off('update_person')
            EventBus.$off('create_person')
        }

    }
</script>
